import { useQuery } from '@apollo/react-hooks';
import { getShoppingListsQuery } from '../../queries/shoppingList';

export default () => {
  const { loading, data } = useQuery(getShoppingListsQuery, { fetchPolicy: 'no-cache' });

  return { loading, shoppingLists: data && data.me.shoppingLists };
};
